var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSailingBoat = function SvgSailingBoat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M.75 23.263a5.51 5.51 0 0 0 4.5-1.5 4.547 4.547 0 0 0 6.75 0 4.547 4.547 0 0 0 6.75 0 5.51 5.51 0 0 0 4.5 1.5m-1.493-2.992a6.2 6.2 0 0 0 1.429-1.954.75.75 0 0 0-.686-1.054h-21a.75.75 0 0 0-.686 1.054A6.46 6.46 0 0 0 2.6 20.591"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M11.25 17.263V2.03a1.267 1.267 0 0 0-2.284-.756L2.271 11.6a.75.75 0 0 0 .629 1.161l8.348-.012m4.383-6.838a.75.75 0 0 0-1.381.406v7.946h5.376a.751.751 0 0 0 .631-1.156z"
  }))));
};
export default SvgSailingBoat;